import React, { useState } from "react";
import arrowDownIcon from "../../assets/icons/down_arrow_bar.svg";

interface QuestionAnswer {
  question: string;
  answer: string;
}

interface AccordionProps {
  questionsAndAnswers: QuestionAnswer[];
  showBorder: boolean;
}

const QAaccordian: React.FC<AccordionProps> = ({ questionsAndAnswers, showBorder }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="w-full">
      {questionsAndAnswers
        ?.filter((qa: any) => qa.status?.toLowerCase() !== "disabled")
        .sort((a: any, b: any) => (a?.position ?? 0) - (b?.position ?? 0))
        .map((qa, index) => (
          <div key={index} className={`${
            showBorder && index < questionsAndAnswers.length - 1 ? "border-b pb-1" : ""
          }`}>
            <button
              onClick={() => toggleAccordion(index)}
              className="flex justify-between items-center w-full px-4 pt-4 text-left text-lg font-medium text-gray-800 focus:outline-none"
            >
              <div className="text-[14px] font-normal pr-4 break-normal">
                {qa.question}
              </div>

              <img
                src={arrowDownIcon}
                className={`transform transition-transform w-[8px] duration-200 ${
                  activeIndex === index ? "rotate-180" : ""
                }`}
                alt=""
              />
            </button>
            {activeIndex === index && (
              <div className="text-[14px] font-normal pr-6 md:pr-10 pl-4 pb-2  text-gray-500 break-normal">
                {qa.answer}
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default QAaccordian;
